import { ThemeEvents } from '@theme/events'
import { useReduced } from '@theme/maths'
import { isMobile } from '@theme/use-device-detection'

function initAnchorScroll(lenis) {
  const durationDefault = 1.47

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-anchor-target]')
    if (!trigger) return

    const target = trigger.getAttribute('data-anchor-target')
    if (!target) return

    event.preventDefault()
    lenis.scrollTo(target, {
      offset: 0,
      duration: durationDefault,
      easing: (x) => (x < 0.5 ? 8 * x * x * x * x : 1 - (-2 * x + 2) ** 4 / 2)
    })
  })
}

function wantsInfiniteScroll() {
  return document.querySelector('[data-typo-scroll-infinite="true"]') !== null
}

function resizeAfterFonts(lenis) {
  if (!document.fonts?.ready) return
  document.fonts.ready.then(() => lenis.resize())
}

function initSmoothScroll() {
  if (useReduced()) return

  const infinite = wantsInfiniteScroll()
  if (isMobile() && !infinite) return
  if (!(window.gsap && window.Lenis)) return

  const lenis = new window.Lenis({
    lerp: infinite ? 0.1 : 0.165,
    wheelMultiplier: infinite ? 1 : 1.25,
    infinite,
    syncTouch: infinite
  })
  window.lenis = lenis

  resizeAfterFonts(lenis)
  lenis.on('scroll', () => window.ScrollTrigger?.update())
  window.gsap.ticker.add((time) => lenis.raf(time * 1000))

  const toggleScrollLock = ({ isLocked }) => {
    if (isLocked) lenis.stop()
    else lenis.start()
  }

  const isLocked = document.documentElement.classList.contains('nav-is-open')
  toggleScrollLock({ isLocked })
  document.addEventListener(ThemeEvents.scrollLockChanged, ({ detail }) => {
    toggleScrollLock(detail)
  })

  initAnchorScroll(lenis)
}

initSmoothScroll()
